export default () => !!localStorage.getItem('LOGGED_IN')
